export default __webpack_public_path__ + "static/media/NC.936fc86f.jpg";